// extracted by mini-css-extract-plugin
module.exports = {"section_partner":"partner_section_partner__0yG3Y","sub_title":"partner_sub_title___jkq0"};